import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { createEvent } from '../../../store/actions/eventActions';

const CreateEventModal = ({ show, handleClose }) => {

  const dispatch = useDispatch();

  const [eventData, setEventData] = useState({
    event_name: '',
    event_description: '',
    event_date: '',
    event_time: '',
    event_location: '',
    organizer_name: '',
    event_type: '',
    target_audience: 'Children',
    capacity: '',
    event_status: 'Upcoming',
    event_duration: '',
    event_image: '' // Event image field added
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEventData({
      ...eventData,
      [name]: value
    });
  };

  // Function to reset form data
  const resetForm = () => {
    setEventData({
      event_name: '',
      event_description: '',
      event_date: '',
      event_time: '',
      event_location: '',
      organizer_name: '',
      event_type: '',
      target_audience: '',
      capacity: '',
      event_status: 'Upcoming', // Reset to default
      event_duration: '',
      event_image: ''
    });
  };

  // Handle file input change for event image
  const handleFileChange = (e) => {
    setEventData({
      ...eventData,
      event_image: e.target.files[0] // Get the selected file
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createEvent(eventData, resetForm, handleClose));
  };

  const handleModalClose = () => {
    handleClose();
  };

  return (
    <Modal show={show} size='lg' onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Event</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            {/* First Column */}
            <Col md={6}>
              <Form.Group controlId="event_name">
                <Form.Label>Event Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event name"
                  name="event_name"
                  value={eventData.event_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="event_date">
                <Form.Label>Event Date</Form.Label>
                <Form.Control
                  type="date"
                  name="event_date"
                  value={eventData.event_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="event_location">
                <Form.Label>Event Location</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event location"
                  name="event_location"
                  value={eventData.event_location}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="organizer_name">
                <Form.Label>Organizer Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter organizer's name"
                  name="organizer_name"
                  value={eventData.organizer_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="capacity">
                <Form.Label>Capacity</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter capacity"
                  name="capacity"
                  value={eventData.capacity}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {/* Second Column */}
            <Col md={6}>
              <Form.Group controlId="event_description">
                <Form.Label>Event Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter event description"
                  name="event_description"
                  value={eventData.event_description}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="event_time">
                <Form.Label>Event Time</Form.Label>
                <Form.Control
                  type="time"
                  name="event_time"
                  value={eventData.event_time}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="event_type">
                <Form.Label>Event Type</Form.Label>
                <Form.Select
                  name="event_type"
                  value={eventData.event_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select event type</option>
                  <option value="Workshop">Workshop</option>
                  <option value="Celebration">Celebration</option>
                  <option value="Seminar">Seminar</option>
                  <option value="Conference">Conference</option>
                  <option value="Webinar">Webinar</option>
                  <option value="Social Event">Social Event</option>
                  <option value="Fundraiser">Fundraiser</option>
                  <option value="Festival">Festival</option>
                  <option value="Exhibition">Exhibition</option>
                  <option value="Sports Event">Sports Event</option>
                  <option value="Competition">Competition</option>
                </Form.Select>
              </Form.Group>

              <Form.Group controlId="event_status">
                <Form.Label>Event Status</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter event status"
                  name="event_status"
                  value={eventData.event_status}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="event_duration">
                <Form.Label>Event Duration</Form.Label>
                <Form.Select
                  name="event_duration"
                  value={eventData.event_duration}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select event duration</option>
                  <option value="1 day">1 day</option>
                  <option value="2 - 4 days">2 - 4 days</option>
                  <option value="1 week">1 week</option>
                  <option value="2 weeks">2 weeks</option>
                  <option value="1 month">1 month</option>
                  <option value="Custom duration">Custom duration</option>
                </Form.Select>
              </Form.Group>

              {/* Event Image Upload */}
              <Form.Group controlId="event_image">
                <Form.Label>Event Image</Form.Label>
                <Form.Control
                  type="file"
                  name="event_image"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateEventModal;
